import { TypedEmitter } from 'tiny-typed-emitter';
export const notifier = new TypedEmitter();
